// extracted by mini-css-extract-plugin
export default {"flagText":"fZy6LRDj","GenericFlagLink":"Gc3v48sF","GenericFlagCopy":"IRlOjAQs","GenericFlag":"nTINLnuw","GenericFlagGeneric":"hWGIcWlT","GenericFlagClose":"psR7ZPaJ"};